var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.1111C21 15.6022 20.6084 16 20.125 16H0.875C0.391562 16 0 15.6022 0 15.1111V0.888889C0 0.397778 0.391562 0 0.875 0H20.125C20.6084 0 21 0.397778 21 0.888889V15.1111Z",
    fill: "#009C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4863 2.68066L2.61133 8.00022L10.4863 13.3473L18.3885 8.00022L10.4863 2.68066Z",
    fill: "#FFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5554C12.433 11.5554 14 9.96357 14 7.99989C14 6.03621 12.433 4.44434 10.5 4.44434C8.567 4.44434 7 6.03621 7 7.99989C7 9.96357 8.567 11.5554 10.5 11.5554Z",
    fill: "#052379"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3851 7.0899C10.8321 6.80901 10.241 6.66724 9.62675 6.66724C8.64806 6.66724 7.73763 7.03168 7.03325 7.65924C7.02275 7.77346 7 7.88324 7 8.00013C7 8.30501 7.04944 8.59568 7.12031 8.8779C7.68819 8.05346 8.61219 7.55613 9.62719 7.55613C10.1041 7.55613 10.5639 7.66679 10.9939 7.88501C12.0942 8.44368 12.7107 9.5899 12.6766 10.7641C12.9859 10.5126 13.2536 10.2152 13.4641 9.87213C13.2296 8.7099 12.5081 7.66013 11.3851 7.0899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.15bde710.svg";
export { ForwardRef as ReactComponent };